import './App.css';
import Menu from './components/common/Menu';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import Home from './views/Home';
import About from './views/About';
import Contact from './views/Contact';
import Footer from './components/common/Footer';
import Blog from './views/Blog';
import MessengerCustomerChat from 'react-messenger-customer-chat';
import Works from './views/Works';

function App() {
  return (
    <div className="app">
      <Router >
        <Menu />
        <Switch>
          <Route exact path="/">
            <Home />
          </Route>
          <Route path="/about">
            <About />
          </Route>
          <Route path="/works">
            <Works />
          </Route>
          <Route path="/blogs">
            <Blog />
          </Route>
          <Route path="/contact">
            <Contact />
          </Route>
        </Switch>
        <MessengerCustomerChat pageId="1156044264475391" appId="217784243280731" />
        <Footer />
      </Router>
    </div>
  );
}

export default App;
